export default __webpack_public_path__ + "static/media/SA_BS.96c5b19c.png";